import { render, staticRenderFns } from "./tpaListagem.vue?vue&type=template&id=f040b7ce&scoped=true&"
import script from "./tpaListagem.vue?vue&type=script&lang=js&"
export * from "./tpaListagem.vue?vue&type=script&lang=js&"
import style0 from "./tpaListagem.vue?vue&type=style&index=0&id=f040b7ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f040b7ce",
  null
  
)

export default component.exports